import { isSubscriber } from '@alltrails/context/utils/isSubscriber';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import type { User } from '@alltrails/types/User';

type IsTripPlannerAvailableArgs = {
  languageRegionCode?: LanguageRegionCode;
  user?: User | null;
};

/**
 * isTripPlannerAvailable checks that the user can access the trip planner.
 * The trip planner has no dedicated feature entitlement, so access is granted to any paid tier.
 * The trip planner is not translated, so it is limited to en-US.
 */
export const isTripPlannerAvailable = ({ languageRegionCode, user }: IsTripPlannerAvailableArgs) =>
  languageRegionCode === 'en-US' && isSubscriber(user);
